import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Icon-right-hover",
  "use": "icon-Icon-right-hover-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-Icon-right-hover\"><rect width=\"24\" height=\"24\" rx=\"4\" fill=\"#ECF0FB\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.793 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L13.086 12 8.793 7.707a1 1 0 0 1 0-1.414Z\" fill=\"#4066D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol